import type { ReadingMap as ReadingMapType, ReadingMapItem } from "@/types/book";

function Section({
  label,
  items,
}: {
  label: string;
  items: ReadingMapItem[];
}) {
  if (!items || items.length === 0) return null;

  return (
    <div className="space-y-4">
      <h3 className="font-semibold">{label}</h3>
      <ul className="space-y-4">
        {items.map((item, i) => (
          <li key={i}>
            <p className="font-medium">{item.topic}</p>
            <p className="text-muted-foreground leading-relaxed">{item.why}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}

export function ReadingMap({ readingMap }: { readingMap: ReadingMapType }) {
  return (
    <div className="space-y-8">
      <Section label="Focus On" items={readingMap.focus_on ?? []} />
      <Section label="Skim" items={readingMap.skim ?? []} />
      <Section label="Skip" items={readingMap.skip ?? []} />
    </div>
  );
}
